var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map((function(p){return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = function(scopeName, key) {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = function(scope, key) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key) {
	var versions = scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = function(scope, key, requiredVersion) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = function(scope, scopeName, key, requiredVersion) {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = function(scope, scopeName, key, requiredVersion) {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var init = function(fn) { return function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
}; };

var load = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/react-dom/react-dom": function() { return loadSingletonVersionCheckFallback("default", "react-dom", [0,18], function() { return __webpack_require__.e(1542).then(function() { return function() { return __webpack_require__("../node_modules/react-dom/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react/react": function() { return loadSingletonVersionCheckFallback("default", "react", [0,18], function() { return __webpack_require__.e(7378).then(function() { return function() { return __webpack_require__("../node_modules/react/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react-router-6/react-router?6324": function() { return loadSingletonFallback("default", "react-router-6", function() { return Promise.all([__webpack_require__.e(6403), __webpack_require__.e(4935)]).then(function() { return function() { return __webpack_require__("../node_modules/react-router/dist/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react-router-dom/react-router-dom?1c7a": function() { return loadStrictVersionCheckFallback("default", "react-router-dom", [0,5,3,4], function() { return Promise.all([__webpack_require__.e(6403), __webpack_require__.e(5783), __webpack_require__.e(7736)]).then(function() { return function() { return __webpack_require__("../node_modules/react-router-dom/dist/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react-router-6/react-router?91bc": function() { return loadSingletonVersionCheckFallback("default", "react-router-6", [4,6,30,0], function() { return __webpack_require__.e(4935).then(function() { return function() { return __webpack_require__("../node_modules/react-router/dist/index.js"); }; }); }); },
	"webpack/sharing/consume/default/@amzn/austin-core/@amzn/austin-core?8b00": function() { return loadSingletonVersionCheckFallback("default", "@amzn/austin-core", [1,2,142,0], function() { return Promise.all([__webpack_require__.e(3801), __webpack_require__.e(5049), __webpack_require__.e(9459), __webpack_require__.e(5482), __webpack_require__.e(4952), __webpack_require__.e(4717), __webpack_require__.e(9587), __webpack_require__.e(1339), __webpack_require__.e(1614), __webpack_require__.e(2275), __webpack_require__.e(7380), __webpack_require__.e(2226), __webpack_require__.e(5520), __webpack_require__.e(4060), __webpack_require__.e(6389), __webpack_require__.e(6817), __webpack_require__.e(6176), __webpack_require__.e(9020), __webpack_require__.e(2641)]).then(function() { return function() { return __webpack_require__("../node_modules/@amzn/austin-core/dist/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react-router-dom/react-router-dom?1a3e": function() { return loadStrictVersionCheckFallback("default", "react-router-dom", [1,6,30,0], function() { return Promise.all([__webpack_require__.e(6403), __webpack_require__.e(5783), __webpack_require__.e(6176), __webpack_require__.e(7736)]).then(function() { return function() { return __webpack_require__("../node_modules/react-router-dom/dist/index.js"); }; }); }); },
	"webpack/sharing/consume/default/@amzn/austin-core/@amzn/austin-core?b1a7": function() { return loadSingletonVersionCheckFallback("default", "@amzn/austin-core", [4,2,93,0], function() { return Promise.all([__webpack_require__.e(5049), __webpack_require__.e(9459), __webpack_require__.e(5482), __webpack_require__.e(4952), __webpack_require__.e(4717), __webpack_require__.e(9587), __webpack_require__.e(1339), __webpack_require__.e(1614), __webpack_require__.e(2275), __webpack_require__.e(7380), __webpack_require__.e(2226), __webpack_require__.e(5520), __webpack_require__.e(4060), __webpack_require__.e(6389), __webpack_require__.e(6817), __webpack_require__.e(6176), __webpack_require__.e(9020), __webpack_require__.e(8571)]).then(function() { return function() { return __webpack_require__("../node_modules/@amzn/austin-core/dist/index.js"); }; }); }); }
};
// no consumes in initial chunks
var chunkMapping = {
	"1287": [
		"webpack/sharing/consume/default/react/react"
	],
	"1610": [
		"webpack/sharing/consume/default/@amzn/austin-core/@amzn/austin-core?b1a7"
	],
	"6176": [
		"webpack/sharing/consume/default/react-dom/react-dom"
	],
	"7736": [
		"webpack/sharing/consume/default/react-router-6/react-router?91bc"
	],
	"9020": [
		"webpack/sharing/consume/default/react-router-6/react-router?6324",
		"webpack/sharing/consume/default/react-router-dom/react-router-dom?1c7a"
	],
	"9124": [
		"webpack/sharing/consume/default/@amzn/austin-core/@amzn/austin-core?8b00",
		"webpack/sharing/consume/default/react-router-dom/react-router-dom?1a3e"
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}